export default "__VITE_ASSET__DMwp0o0D__"